import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function WordPressToolLandingPage() {
  const { isAuthenticated } = useAuth();
  const entryPath = isAuthenticated ? "/tools/wpa/dashboard" : "/login?next=%2Ftools%2Fwpa%2Fdashboard";

  return (
    <main className="page-grid wpa-landing">
      <section className="wpa-hero">
        <div className="wpa-hero-copy">
          <p className="landing-eyebrow">WordPress Website Assessment Tool</p>
          <h2>Audit WordPress Websites With Clarity, Speed, and Decision-Ready Insights</h2>
          <p>
            Built for consulting teams to evaluate website health, architecture risks, plugin stability, performance,
            security posture, and incident impact in one structured operating flow.
          </p>
          <div className="wpa-hero-chips">
            <span>Architecture Intelligence</span>
            <span>Incident Evidence Mapping</span>
            <span>Executive Recommendation Reports</span>
          </div>
          <p className="muted">Public permalink: <strong>/tools/wpa</strong></p>
        </div>
        <div className="wpa-entry-spotlight">
          <p className="landing-eyebrow">Ready To Begin</p>
          <h3>Enter the live workspace and continue from your latest assessment context</h3>
          <p>Sign in once and you will be redirected directly into the WordPress assessment workspace.</p>
          <div className="wpa-entry-actions">
            <Link to={entryPath} className="wpa-entry-button">
              Enter WordPress Website Assesment Tool Workspace
            </Link>
          </div>
        </div>
      </section>

      <section className="wpa-highlights">
        <p className="landing-eyebrow">Assessment Highlights</p>
        <h3>Complete WordPress assessment coverage in one interface</h3>
        <div className="wpa-highlights-grid">
          <article className="wpa-highlight-card">
            <span className="wpa-highlight-icon">BA</span>
            <h4>Business Alignment</h4>
            <p>Connect technical observations to business priorities and decision impact.</p>
          </article>
          <article className="wpa-highlight-card">
            <span className="wpa-highlight-icon">DQ</span>
            <h4>Discovery Questionnaire</h4>
            <p>Use structured prompts to gather context, evidence, and risk signals.</p>
          </article>
          <article className="wpa-highlight-card">
            <span className="wpa-highlight-icon">IR</span>
            <h4>Incident + Root Cause</h4>
            <p>Capture incidents with cause mapping and practical recovery narrative.</p>
          </article>
          <article className="wpa-highlight-card">
            <span className="wpa-highlight-icon">RR</span>
            <h4>Report Readiness</h4>
            <p>Generate consulting-grade summaries for stakeholders and leadership.</p>
          </article>
        </div>
      </section>

      <section className="wpa-feature-grid">
        <article className="card-modern">
          <h4>What You Can Assess</h4>
          <ul>
            <li>Business impact vs technical risk mapping</li>
            <li>Hosting, security, and performance diagnostics</li>
            <li>WordPress core, themes, and plugin stability</li>
            <li>Governance, ownership, and recovery readiness</li>
          </ul>
        </article>
        <article className="card-modern">
          <h4>Who Uses This Tool</h4>
          <ul>
            <li>Internal consulting and transformation teams</li>
            <li>Solution architects and delivery leads</li>
            <li>Account management and customer success teams</li>
            <li>Operations, infra, and platform owners</li>
          </ul>
        </article>
        <article className="card-modern">
          <h4>Structured Workflow</h4>
          <ol>
            <li>Select website workspace</li>
            <li>Complete stage-wise assessment prompts</li>
            <li>Capture incidents and evidence trails</li>
            <li>Review preview and generate reports</li>
          </ol>
        </article>
        <article className="card-modern">
          <h4>Key Outcomes</h4>
          <ul>
            <li>Faster risk identification and prioritization</li>
            <li>Clear stakeholder communication</li>
            <li>Practical next-step recommendations</li>
            <li>Reusable audit knowledge base</li>
          </ul>
        </article>
      </section>

      <section className="card-modern wpa-bottom-note">
        <h4>Designed For Repeatable, High-Trust Delivery</h4>
        <p>
          This tool converts scattered analysis into a single repeatable framework so your team can diagnose faster,
          decide better, and communicate recommendations with confidence.
        </p>
        <div className="hero-actions">
          <Link to={entryPath} className="button-link">Open Workspace</Link>
        </div>
      </section>
    </main>
  );
}
